import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { IServiceDetails } from '../../models/shipment-price.interface';
import { ShipmentPriceService } from '../shipment-price.service';

@Injectable()
export class SingleServiceResolver implements Resolve<IServiceDetails> {
    constructor(
        private shipmentPriceSvc: ShipmentPriceService,
    ) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IServiceDetails> {
        const {id} = route.params;
        console.log(id);
        return this.shipmentPriceSvc.getServiceDetailsById(id);
    }
}
